// Server hard cap on how many items a parallel Iterate loop runs at once. The runtime clamps
// `options.parallel.parallelWindow` and `maxParallelWindow` to this, the option schema rejects
// larger values, and the editor's slider consumes it as its maximum. Nothing hardcodes the number.
export const PARALLEL_LOOP_MAX_WINDOW = 10;
